import { render, staticRenderFns } from "./SDKMessage.vue?vue&type=template&id=1fa1e6c6"
import script from "./SDKMessage.vue?vue&type=script&lang=js"
export * from "./SDKMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports